// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___pvj1k";
var _2 = "styles-module__coordinates___GvjJc";
var _3 = "styles-module__title____HtJs";
export { _1 as "container", _2 as "coordinates", _3 as "title" }
